export default __webpack_public_path__ + "static/media/church_line_drawing_whole.eb65f857.png";